import React, { Suspense } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import useApp from "../hooks/useApp";
import { LoginScreen, Onboarding } from "../screens";
import { ROUTES, HEADER } from "../constants";
import { isTokenExpired } from "../utils/auth";
import { appRoutes, onboardingRoutes } from "./config";
import { getSessionStorage } from "../utils/storageUtils";

const ProtectedRoute = ({ children }) => {
  let location = useLocation();
  const accessToken = getSessionStorage(HEADER.REFRESH_TOKEN);
  const isExpired = isTokenExpired(accessToken);

  if (isExpired) {
    return (
      <Navigate to={`/${ROUTES.REGISTER}`} state={{ from: location }} replace />
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
};

const Router = () => {
  const { tenantConfig, product, preLoginScreens, preLoginCompleted } =
    useApp();

  const renderAppRoutes = () => {
    return (
      <Routes>
        {appRoutes(tenantConfig).map((routeItem) => {
          const Component = routeItem.component;
          return routeItem.isProtected ? (
            <Route
              key={routeItem.key}
              path={routeItem.path}
              exact={routeItem.exact}
              element={
                <ProtectedRoute>
                  <Component />
                </ProtectedRoute>
              }
            />
          ) : (
            <Route
              key={routeItem.key}
              path={routeItem.path}
              exact={routeItem.exact}
              element={<Component />}
            />
          );
        })}
        <Route path="*" element={<LoginScreen />} />
      </Routes>
    );
  };

  const renderOnboardingRoutes = () => {
    return (
      <Routes>
        {onboardingRoutes(product).map((routeItem) => {
          return (
            <Route
              key={routeItem.key}
              path={routeItem.path}
              exact={routeItem.exact}
              Component={routeItem.component}
            />
          );
        })}
        <Route path="*" element={<Onboarding />} />
      </Routes>
    );
  };
  return (
    <Suspense fallback={null}>
      {preLoginScreens.length &&
      !preLoginCompleted &&
      !window.location.pathname.includes(ROUTES.PARTNER_JOURNEY)
        ? renderOnboardingRoutes()
        : renderAppRoutes()}
    </Suspense>
  );
};

export default Router;
